import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import toHtml from "html-react-parser";
import Breadcrums from "../../../common/breadcrumbs";
import Loader from "../../../common/loader";
import { breakWord, formateDate, showStatus } from "../../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
import { Placeholder } from "rsuite";
import * as ParentAdmin from "../../../services/parentAdmin.service";

const ParentAdminView = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const [showdefault, setShowDefault] = useState({});
  const [childData, setChildData] = useState([]);
  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: t("Parent"), url: "/admin/user-management/parent-admins/list/1" },
    { title: t("btn_view"), url: "" },
  ];

  useEffect(() => {
    ParentAdmin
      .Details(params.pgno)
      .then((data) => {
        setShowDefault(data && data.data ? data.data : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, []);

  useEffect(() => {
    ParentAdmin
      .inChild(params.pgno)
      .then((data) => {
        setChildData(data && data?.data && data?.data?.children || []);
      })
  }, [])

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div>
                <h6 className="main-content-label mb-3">Parent Admin View</h6>
              </div>
              {showdefault && Object.keys(showdefault)?.length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table
                      id="simple-table"
                      className="table  table-bordered table-hover"
                    >
                      <tbody>
                        <tr>
                          <th>{t("label_name")} </th>
                          <td className="text-capitalize">
                            {showdefault && showdefault?.firstName
                              ? showdefault.firstName
                              : "N/A"} {showdefault && showdefault?.lastName
                                ? showdefault.lastName
                                : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("label_email")}</th>
                          <td>
                            {showdefault && showdefault.email
                              ? showdefault.email
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("label_gender")}</th>
                          <td>
                            {showdefault && showdefault.gender
                              ? showdefault.gender
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("label_address")}</th>
                          <td>
                            {showdefault && showdefault.clubDetails.address
                              ? showdefault.clubDetails.address
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("label_city")}</th>
                          <td>
                            {showdefault && showdefault.clubDetails.city
                              ? showdefault.clubDetails.city
                              : showdefault?.city ? showdefault?.city : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("label_state")}</th>
                          <td>
                            {showdefault && showdefault.clubDetails.state
                              ? showdefault.clubDetails.state
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("label_country")}</th>
                          <td>
                            {showdefault && showdefault.clubDetails.country
                              ? showdefault.clubDetails.country
                              : showdefault?.country ? showdefault?.country : "N/A"}
                          </td>
                        </tr>
                    
                        <tr>
                          <th>{t("label_zipcode")}</th>
                          <td>
                            {showdefault && showdefault.clubDetails.zipCode
                              ? showdefault.clubDetails.zipCode
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_club_name")}</th>
                          <td>
                            {showdefault && showdefault.clubDetails.name
                              ? showdefault.clubDetails.name
                              : "N/A"}
                          </td>
                        </tr>
                          <tr>
                          <th>{t("Club Email")}</th>
                          <td>
                            {showdefault && showdefault.clubEmail
                              ? showdefault.clubEmail
                              : "N/A"}
                          </td>
                        </tr>
                        {/* <tr>
                          <th>{t("label_phone")}</th>
                          <td>
                            {showdefault && showdefault.phone_number
                              ? showdefault.phone_number
                              : "N/A"}
                          </td>
                        </tr> */}
                        <tr>
                          <th>{t("list_heading_status")}</th>
                          <td>
                            {showdefault && showdefault?.status === 0
                              ? toHtml(showStatus(showdefault.status))
                              : toHtml(showStatus(showdefault.status))}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("list_heading_created_date")}</th>
                          <td>
                            {showdefault && showdefault.createdAt
                              ? formateDate(showdefault.createdAt)
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("label_modified_date")}</th>
                          <td>
                            {showdefault && showdefault?.updatedAt
                              ? formateDate(showdefault.updatedAt)
                              : "N/A"}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                <Placeholder.Paragraph className="w-100 admin-placeholder" rowHeight={30} rowSpacing={5} active={true} rows={7} />
              )}

              {/* ================= CHILD DATA TABLE ================= */}
              <h6 className="main-content-label mb-3">
                {t("label_player_data")}
              </h6>
              <table className="table table-bordered table-hover mt-4">
                <thead>
                  <tr>
                    <th>{t("list_heading_sno")}</th>
                    <th>{t("label_name")}</th>
                    <th>{t("label_email")}</th>
                  </tr>
                </thead>
                <tbody>
                  {childData?.length > 0 ? (
                    childData.map((child, index) => (
                      <tr key={child.id || index}>
                        <td>{index + 1}</td>
                        <td>{child && child?.name ? child?.name : "N/A"}</td>
                        <td>{child && child?.email ? child.email : "N/A"}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3" className="text-center">
                        {t("label_no_data_found")}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              <div className="mt-4">
                <button
                  className="btn ripple btn-dark"
                  type="button"
                  onClick={() => navigate(-1)}
                >
                  <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                  {t("btn_back")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ParentAdminView;
